export const getClosestElement = (element: HTMLElement | null, identifier: string): HTMLElement | null => {
  if (element === null) {
    return null
  }

  return element.closest(`[data-js=${identifier}]`)
}

export const getElement = (identifier: string): HTMLElement | null => document.querySelector(`[data-js=${identifier}]`)

export const getElementChild = (element: HTMLElement | null, identifier: string): HTMLElement | null => {
  if (element === null) {
    return null
  }

  return element.querySelector(`[data-js=${identifier}]`)
}

export const getElementChildren = (element: HTMLElement | null, identifier: string): [] | NodeListOf<HTMLElement> => {
  if (element === null) {
    return []
  }

  return element.querySelectorAll(`[data-js=${identifier}]`)
}

export const getElements = (identifier: string): NodeListOf<HTMLElement> => document.querySelectorAll(`[data-js=${identifier}]`)

export const getElementSibling = (element: HTMLElement | null, identifier: string): HTMLElement | null => {
  if (element === null) {
    return null
  }

  let sibling = element.nextElementSibling

  while (sibling) {
    if (sibling.matches(`[data-js=${identifier}]`) === true) {
      return sibling as HTMLElement
    }

    sibling = sibling.nextElementSibling
  }

  return null
}

export const getElementsWhichStartsWith = (identifier: string): NodeListOf<HTMLElement> => document.querySelectorAll(`[data-js^=${identifier}]`)

export const getTemplate = (identifier: string): HTMLElement | null => {
  const templateElement = getElement(identifier) as HTMLTemplateElement | null

  if (templateElement === null) {
    return null
  }

  return templateElement?.content.cloneNode(true) as HTMLElement
}
